import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

import type { AnalysisFailureCode } from "../../model/Analysis";
import { FAILURE_MESSAGES } from "../../model/FAILURE_MESSAGES";
import { SeverityDot } from "@/shared/ui/severity-dot";
import { StartAnalysisButton } from "../StartAnalysisButton";

const TITLE = msg({ id: "analysis.failed.title", message: "The analysis failed" });
const RETRY = msg({ id: "analysis.failed.retry", message: "Try again" });

type AnalysisFailedProps = {
  matchId: number;
  // `null` — бэкенд не передал код; показывается общая причина.
  error: AnalysisFailureCode | null;
};

// Разбор закончился `failed`: причина по коду и повторный запуск.
// Битые данные матча повтор не исправит — кнопки нет.
export const AnalysisFailed = ({ matchId, error }: AnalysisFailedProps) => {
  const { _ } = useLingui();
  const code = error ?? "internal_error";
  return (
    <section
      data-analysis-state="failed"
      aria-labelledby="analysis-failed-title"
      className="flex flex-col gap-3 rounded-xl border border-bad/40 bg-bad/10 px-4.5 py-4"
    >
      <h2 id="analysis-failed-title" className="flex items-center gap-2 text-lg font-semibold">
        <SeverityDot severity="bad" />
        {_(TITLE)}
      </h2>
      <p className="text-sm text-foreground-soft">{_(FAILURE_MESSAGES[code])}</p>
      {code !== "invalid_match_data" && (
        <StartAnalysisButton matchId={matchId} label={RETRY} variant="outline" />
      )}
    </section>
  );
};
